const autoNgTemplateLoaderTemplate1 = require('./ldap-custom-user-search.html');

import controller from './ldap-custom-user-search.controller';

export const ldapCustomUserSearch = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
  bindings: {
    settings: '=',
    onSearchClick: '<',
    limitedFeatureId: '<',
  },
};
